<template>
  <div class="flex min-h-screen flex-col">
    <Header />
    <!-- 메인+푸터를 동일 가로 기준(min-width)으로 묶어 우측 빈 영역 방지 -->
    <div class="layout-scroll-shell" :class="{ 'overflow-x-auto': !isOrderRoute }">
      <div class="layout-content-shell" :class="contentShellClass">
        <main
          class="flex-1"
          :style="{
            marginTop: isHeaderOverlay ? '0px' : '64px',
            paddingTop: isMypageRoute ? '16px' : '0px',
          }"
        >
          <slot />
        </main>
        <Footer v-if="showFooter" :style="{ marginTop: isHomeRoute ? '0px' : '130px' }" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Header from '@/components/layout/fragments/Header.vue';
import Footer from '@/components/layout/fragments/Footer.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();

/**
 * Footer 표시 여부를 계산
 * meta.footer가 명시적으로 false인 경우에만 숨김
 */
const showFooter = computed(() => route.meta?.footer !== false);

const isHeaderOverlay = computed(() => route.meta?.headerOverlay === true);
const isHomeRoute = computed(() => route.name === 'home');
const isOrderRoute = computed(() => route.name === 'order');
/** 마이페이지(알림센터·로그인 이력·OPEN API 관리 등 동일 레이아웃) 상단 16px 여백 */
const isMypageRoute = computed(() => route.name === 'mypage');

/**
 * layout-content-shell 최소 너비 클래스를 계산
 * order 화면은 자체적으로 뷰포트 전체를 채우므로 레이아웃 레벨 min-width 불필요
 */
const contentShellClass = computed(() => {
  if (isOrderRoute.value) return '';
  if (isHomeRoute.value) return 'min-w-[82rem] lg:min-w-[84rem]';
  return 'min-w-[1920px]';
});
</script>
